export const MaintenanceActionTypes = [
  {
    value: "MATCHING_LIVE",
    label: "matching live"
  },
  {
    value: "MATCHING_OFFICIAL",
    label: "matching official"
  },
  {
    value: "UPDATE_DEMO",
    label: "update demo"
  },
  {
    value: "CANCEL_CERTIFICATES",
    label: "cancel certificates"
  },
  {
    value: "INCREMENTAL_MATCHING_OFFICIAL",
    label: "incremental matching official"
  },
  {
    value: "DAILY_OFFICIAL_CERTIFICATE_GENERATION",
    label: "daily official certificate generation"
  },
  {
    value: "DAILY_LIVE_CERTIFICATE_GENERATION",
    label: "daily live certificate generation"
  }
  /*,
  {
    value: "CANCEL_CERTIFICATES_AND_REPLAY_LIVE",
    label: "cancel certificates and replay matching live"
  },
  {
    value: "CANCEL_CERTIFICATES_AND_REPLAY_OFFICIAL",
    label: "cancel certificates and replay matching official"
  }*/
];


// WEBPACK FOOTER //
// ./src/constants/MaintenanceActionTypes.js